import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { useLaunchCountdown } from '../../hooks/useLaunchCountdown';
import { PRICING, PRICING_OPTIONS } from '../../data/content';
const BENEFITS = ['6 tomos completos, desde nivel inicial', '5 bonos exclusivos incluidos', 'Modelos para crear, usar y vender', 'Acceso 100% digital e inmediato', 'Garantía de 7 días'];
export function Pricing() {
  const {
    isExpired
  } = useLaunchCountdown();
  const product = PRICING_OPTIONS[0];
  if (!product) return null;
  return <section className="w-full px-5 py-14 sm:py-20" aria-labelledby="pricing-title" data-id="element-176" data-mp="3ugrn9fv5u2z1">
      <div className="mx-auto max-w-xl" data-id="element-177" data-mp="3a6xs0kr7344">
        <Reveal className="text-center" data-id="element-178" data-mp="205304qeryu3k">
          <SectionBadge data-id="element-179" data-mp="2064htdqaqeu9">{isExpired ? 'Acceso disponible' : 'Oferta de lanzamiento'}</SectionBadge>
          <h2 id="pricing-title" tabIndex={-1} className="mt-5 font-display text-3xl leading-tight text-cocoa outline-none sm:text-5xl" data-id="element-180" data-mp="25465yd2kx4cl">
            Tu colección empieza <span className="italic text-terra" data-id="element-181" data-mp="16ji6v428onwk">hoy</span>
          </h2>
        </Reveal>

        <Reveal delay={60} className="mt-10" data-id="element-182" data-mp="11knk5r15if76">
          <article className="rounded-3xl border-2 border-terra bg-cream-card px-5 py-7 shadow-[0_24px_60px_rgba(58,41,32,0.14)] sm:p-9" data-id="element-183" data-mp="11lgj45tvc0er">
            <header className="text-center" data-id="element-184" data-mp="1u9m4musqxtfn">
              <h3 className="font-display text-[26px] leading-tight text-cocoa sm:text-3xl" data-id="element-185" data-mp="1u8b4r62f95tt">{product.name}</h3>
              <p className="mt-1.5 text-sm font-extrabold uppercase tracking-wide text-terra" data-id="element-186" data-mp="1pb14evdhv9r7">{product.description}</p>

              {!isExpired && <p className="mt-5 text-sm font-semibold text-cocoa-dim line-through" data-id="element-187" data-mp="1g9tkjibq6bgn">
                  {PRICING.totalValueOld} {PRICING.currency}
                </p>}
              <p className={`font-display text-[52px] leading-none text-cocoa sm:text-7xl ${isExpired ? 'mt-5' : 'mt-1'}`} data-id="element-188" data-mp="9vc1gexhtrh8">
                {product.price}{' '}
                <span className="font-sans text-base font-bold text-cocoa-dim" data-id="element-189" data-mp="6bk11p3mh823">{PRICING.currency}</span>
              </p>
              {!isExpired && <p className="mt-2 text-sm font-extrabold text-olive" data-id="element-190" data-mp="bael0udbt2ns">
                  Ahorrás {PRICING.savings} {PRICING.currency}
                </p>}
              <p className="mt-2 text-sm font-bold text-cocoa" data-id="element-191" data-mp="1c7ez6kks50k">
                {isExpired ? 'Precio actualizado · un solo pago' : 'Un solo pago, sin suscripciones'}
              </p>
            </header>

            <ul className="mt-7 space-y-3 border-t border-sand-line pt-6" aria-label={`Incluye ${product.name}`} data-id="element-192" data-mp="3ohyapbuuyvuo">
              {BENEFITS.map(benefit => <li key={benefit} className="flex items-start gap-3 text-sm font-medium leading-snug text-cocoa sm:text-base" data-id="element-193" data-mp="39udc9v8xhkt3">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-olive" aria-hidden="true" data-id="element-194" data-mp="3epam34e17y71" />
                  {benefit}
                </li>)}
            </ul>

            <CtaButton className="mt-8 w-full" href={product.checkoutUrl} data-id="element-195" data-mp="35qfebnvcag1m">
              Quiero acceder ahora <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-196" data-mp="2m5oukxrxdxi6" />
            </CtaButton>

            <p className="mt-3 flex items-center justify-center gap-2 text-xs font-semibold text-cocoa-dim" data-id="element-197" data-mp="2h7wrd7ltyoyo">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-198" data-mp="2v3qsv5k9yc1r" />
              Pago seguro · Acceso inmediato por email
            </p>
          </article>
        </Reveal>
      </div>
    </section>;
}